var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex justify-center", attrs: { id: "app" } },
    [
      _c("i", { staticClass: "pattern", class: "step-" + _vm.step }),
      _vm._v(" "),
      _c("div", { staticClass: "viewport" }, [
        _c(
          "ul",
          { staticClass: "progressbar clearfix flex justify-between relative" },
          [
            _c(
              "li",
              {
                staticClass: "active hoverable w-1/6 flex justify-end",
                on: { click: _vm.resetStep1 }
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _vm.step >= 2
              ? _c(
                  "li",
                  {
                    staticClass: "active hoverable w-1/6 flex justify-end",
                    on: { click: _vm.resetStep2 }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "block w-10 h-10 rounded-full flex items-center justify-center",
                        class: {
                          "bg-grey": _vm.step < 2,
                          "bg-blue-lighter": _vm.step >= 2,
                          current: _vm.step === 2
                        }
                      },
                      [
                        _vm.step <= 1
                          ? _c("img", {
                              staticClass: "mx-auto",
                              attrs: {
                                src: require("../../images/Icon/fingerprint.svg")
                              }
                            })
                          : _c("img", {
                              staticClass: "mx-auto",
                              attrs: {
                                src: require("../../images/Icon/fingerprint-white.svg")
                              }
                            })
                      ]
                    )
                  ]
                )
              : _c("li", { staticClass: "w-1/6 flex justify-end" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "block w-10 h-10 rounded-full flex items-center justify-center",
                      class: {
                        "bg-grey": _vm.step < 2,
                        "bg-blue-lighter": _vm.step >= 2,
                        current: _vm.step === 2
                      }
                    },
                    [
                      _vm.step <= 1
                        ? _c("img", {
                            attrs: {
                              src: require("../../images/Icon/fingerprint.svg")
                            }
                          })
                        : _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("../../images/Icon/fingerprint-white.svg")
                            }
                          })
                    ]
                  )
                ]),
            _vm._v(" "),
            _vm.step >= 3
              ? _c(
                  "li",
                  {
                    staticClass: "active hoverable w-1/6 flex justify-end",
                    on: { click: _vm.resetStep3 }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "block w-10 h-10 rounded-full flex items-center justify-center",
                        class: {
                          "bg-grey": _vm.step < 3,
                          "bg-blue-lighter": _vm.step >= 3,
                          current: _vm.step === 3
                        }
                      },
                      [
                        _vm.step < 3
                          ? _c("img", {
                              staticClass: "mx-auto",
                              attrs: {
                                src: require("../../images/Icon/cisor.svg")
                              }
                            })
                          : _c("img", {
                              staticClass: "mx-auto",
                              attrs: {
                                src: require("../../images/Icon/cisor-white.svg")
                              }
                            })
                      ]
                    )
                  ]
                )
              : _c("li", { staticClass: "w-1/6 flex justify-end" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "bg-grey block w-10 h-10 rounded-full flex items-center justify-center"
                    },
                    [
                      _vm.step < 3
                        ? _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("../../images/Icon/cisor.svg")
                            }
                          })
                        : _c("img", {
                            staticClass: "mx-auto",
                            attrs: {
                              src: require("../../images/Icon/cisor-white.svg")
                            }
                          })
                    ]
                  )
                ]),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "w-1/6 flex justify-end",
                class: { active: _vm.step === 4 }
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "block w-10 h-10 rounded-full flex items-center justify-center",
                    class: {
                      "bg-grey": _vm.step < 4,
                      "bg-blue-lighter": _vm.step >= 4,
                      current: _vm.step === 4
                    }
                  },
                  [
                    _vm.step < 4
                      ? _c("img", {
                          attrs: {
                            src: require("../../images/Icon/search.svg")
                          }
                        })
                      : _c("img", {
                          attrs: {
                            src: require("../../images/Icon/search-white.svg")
                          }
                        })
                  ]
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass:
              "text-center py-4 instruction-title flex items-center justify-center"
          },
          [_vm._v(_vm._s(_vm.titleStep))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "wrapperdemo", class: "step-" + this.step }, [
          _c("div", { staticClass: "flex overflow-x-hidden" }, [
            _c(
              "div",
              {
                staticClass: "flex w-full steps",
                class: { "justify-center": _vm.step === 1 }
              },
              [
                _c(
                  "div",
                  { staticClass: "pr-4 w-1/2 w-64 flex-shrink-0 step" },
                  [
                    _c(
                      "h4",
                      { staticClass: "font-bold text-green text-center py-2" },
                      [_vm._v("Original image")]
                    ),
                    _vm._v(" "),
                    _vm.step === 1 && !_vm.originalUploaded
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "box uploadbox border-2 border-green bg-transparent flex items-center justify-center mx-auto",
                            class: { drag: _vm.dragging },
                            on: {
                              click: function($event) {
                                _vm.document.querySelector("#file").click()
                              },
                              drop: _vm.markImage,
                              dragover: function($event) {
                                _vm.event.preventDefault()
                                _vm.dragging = true
                              },
                              dragleave: function($event) {
                                _vm.dragging = false
                              }
                            }
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("input", {
                              staticStyle: { display: "none" },
                              attrs: { id: "file", type: "file" },
                              on: { change: _vm.markImage }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.originalUploaded,
                            expression: "originalUploaded"
                          }
                        ],
                        staticClass: "border-2 border-green"
                      },
                      [_vm._m(2)]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.step >= 2,
                        expression: "step >= 2"
                      }
                    ],
                    staticClass: "w-1/2 flex-shrink-0 pr-4 step"
                  },
                  [
                    _c(
                      "h4",
                      { staticClass: "font-bold text-green text-center py-2" },
                      [_vm._v("Watermarked image")]
                    ),
                    _vm._v(" "),
                    _vm._m(3)
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.step >= 2,
                        expression: "step >= 2"
                      }
                    ],
                    staticClass: "pr-4 w-1/2 w-64 flex-shrink-0 step"
                  },
                  [
                    _c(
                      "h4",
                      { staticClass: "font-bold text-green text-center py-2" },
                      [_vm._v("Modified image")]
                    ),
                    _vm._v(" "),
                    _vm._m(4)
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.step >= 3,
                        expression: "step >= 3"
                      }
                    ],
                    staticClass: "pr-4 w-1/2 w-64 flex-shrink-0 step"
                  },
                  [
                    _c("div", { staticClass: "step-4-title" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.marksearch,
                              expression: "!marksearch"
                            }
                          ]
                        },
                        [
                          _vm.marked
                            ? _c(
                                "h4",
                                {
                                  staticClass:
                                    "font-bold text-green text-center py-2"
                                },
                                [_vm._v("Image certified")]
                              )
                            : _c(
                                "h4",
                                {
                                  staticClass:
                                    "font-bold text-orange text-center py-2"
                                },
                                [_vm._v("Image not certified")]
                              )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "border-2 border-green" }, [
                      _c("div", { staticClass: "box" }, [
                        _c("img", {
                          staticClass: "imgbox",
                          class: { opacityimg: _vm.marksearch },
                          attrs: { id: "detect-preview" }
                        }),
                        _vm._v(" "),
                        _vm.marksearch
                          ? _c("span", { staticClass: "vcenter" }, [
                              _c("i", {
                                staticClass:
                                  "fas fa-circle-notch fa-spin boxicon"
                              })
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex",
              class: { "justify-center": _vm.step === 1 }
            },
            [
              _c(
                "ul",
                { staticClass: "flex bg-black w-1/2 mt-4 controls pr-4" },
                [
                  _c(
                    "li",
                    {
                      staticClass:
                        "mr-1 py-2 px-4 w-1/3 flex justify-center relative",
                      attrs: { "data-tooltip": "" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.resetStep1($event)
                        }
                      }
                    },
                    [
                      _vm.step === 2
                        ? _c("img", {
                            attrs: {
                              src: require("../../images/Icon/edit-green.svg")
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: require("../../images/Icon/edit.svg")
                            }
                          }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bg-green text-white tooltip p-4" },
                        [_vm._v("Reset")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "mr-1 w-1/3 flex justify-center",
                      class: { active: _vm.step === 4 && _vm.grayscale },
                      attrs: { "data-tooltip": "" },
                      on: { click: _vm.drawCroppedImage }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "py-2 px-4 flex justify-center relative z-10 w-full",
                          attrs: { for: "grayscale1" }
                        },
                        [
                          _vm.step === 4
                            ? _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/moon-green.svg")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/moon-blue.svg")
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.grayscale,
                            expression: "grayscale"
                          }
                        ],
                        staticClass: "hidden",
                        attrs: { id: "grayscale1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.grayscale)
                            ? _vm._i(_vm.grayscale, null) > -1
                            : _vm.grayscale
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.grayscale,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.grayscale = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.grayscale = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.grayscale = $$c
                              }
                            },
                            _vm.drawCroppedImage
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bg-green text-white tooltip p-4" },
                        [_vm._v("Grayscale")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "w-1/3 flex justify-center",
                      class: { active: _vm.step === 4 && _vm.toggleQuality },
                      attrs: { "data-tooltip": "" }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "py-2 px-4 flex justify-center relative z-10 w-full",
                          attrs: { for: "quality1" }
                        },
                        [
                          _vm.step === 4
                            ? _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/quality-green.svg")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/quality-blue.svg")
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.toggleQuality,
                            expression: "toggleQuality"
                          }
                        ],
                        staticClass: "hidden",
                        attrs: { id: "quality1", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.toggleQuality)
                            ? _vm._i(_vm.toggleQuality, null) > -1
                            : _vm.toggleQuality
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.toggleQuality,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.toggleQuality = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.toggleQuality = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.toggleQuality = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bg-green text-white tooltip p-4" },
                        [_vm._v("Quality")]
                      ),
                      _vm._v(" "),
                      _vm.step === 4 && _vm.toggleQuality
                        ? _c(
                            "div",
                            { staticClass: "absolute resolution bg-blue" },
                            [
                              _c("div", [
                                _vm._v(
                                  "\n                                Quality: "
                                ),
                                _c("strong", [_vm._v(_vm._s(_vm.quality))]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.quality,
                                      expression: "quality"
                                    }
                                  ],
                                  attrs: {
                                    type: "range",
                                    min: "0",
                                    max: "100"
                                  },
                                  domProps: { value: _vm.quality },
                                  on: {
                                    change: _vm.drawCroppedImage,
                                    __r: function($event) {
                                      _vm.quality = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.step >= 2,
                      expression: "step >= 2"
                    }
                  ],
                  staticClass: "flex bg-black w-1/2 mt-4 controls pr-4"
                },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "mr-1 w-1/3 flex justify-center",
                      class: { active: _vm.step === 3 && _vm.grayscale },
                      attrs: { "data-tooltip": "" },
                      on: { click: _vm.drawCroppedImage }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "py-2 px-4 flex justify-center relative z-10 w-full",
                          attrs: { for: "grayscale2" }
                        },
                        [
                          _vm.step === 3
                            ? _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/moon-green.svg")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/moon-blue.svg")
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.grayscale,
                            expression: "grayscale"
                          }
                        ],
                        staticClass: "hidden",
                        attrs: { id: "grayscale2", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.grayscale)
                            ? _vm._i(_vm.grayscale, null) > -1
                            : _vm.grayscale
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.grayscale,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.grayscale = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.grayscale = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.grayscale = $$c
                              }
                            },
                            _vm.drawCroppedImage
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bg-green text-white tooltip p-4" },
                        [_vm._v("Grayscale")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "w-1/3 flex justify-center",
                      class: { active: _vm.step === 3 && _vm.toggleQuality },
                      attrs: { "data-tooltip": "" }
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "py-2 px-4 flex justify-center relative z-10 w-full",
                          attrs: { for: "quality2" }
                        },
                        [
                          _vm.step === 3
                            ? _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/quality-green.svg")
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("../../images/Icon/quality-blue.svg")
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.toggleQuality,
                            expression: "toggleQuality"
                          }
                        ],
                        staticClass: "hidden",
                        attrs: { id: "quality2", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.toggleQuality)
                            ? _vm._i(_vm.toggleQuality, null) > -1
                            : _vm.toggleQuality
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.toggleQuality,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.toggleQuality = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.toggleQuality = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.toggleQuality = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.step === 3 && _vm.toggleQuality
                        ? _c(
                            "div",
                            { staticClass: "absolute resolution bg-blue" },
                            [
                              _c("div", [
                                _vm._v(
                                  "\n                                Quality: "
                                ),
                                _c("strong", [_vm._v(_vm._s(_vm.quality))]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.quality,
                                      expression: "quality"
                                    }
                                  ],
                                  attrs: {
                                    type: "range",
                                    min: "0",
                                    max: "100"
                                  },
                                  domProps: { value: _vm.quality },
                                  on: {
                                    change: _vm.drawCroppedImage,
                                    __r: function($event) {
                                      _vm.quality = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "bg-green text-white tooltip p-4" },
                        [_vm._v("Quality")]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "flex justify-center" }, [
            _vm.step === 3 || _vm.step === 4
              ? _c(
                  "div",
                  {
                    staticClass: "flex justify-center py-8 mr-4",
                    on: { click: _vm.clickPrevious }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "bg-blue-lighter text-white py-2 mx-auto"
                      },
                      [_vm._v("‹ Previous step")]
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.step === 2 || _vm.step === 3
              ? _c(
                  "div",
                  {
                    staticClass: "flex justify-center py-8",
                    on: {
                      click: function($event) {
                        return _vm.clickNext()
                      }
                    }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "bg-blue-lighter text-white py-2 mx-auto"
                      },
                      [_vm._v("Next step ›")]
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass:
          "bg-blue-lighter block w-10 h-10 rounded-full flex items-center justify-center"
      },
      [
        _c("img", {
          attrs: { src: require("../../images/Icon/upload-white.svg") }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-col items-center justify-between h-full p-8" },
      [
        _c("div", { staticClass: "flex justify-center items-center mt-10" }, [
          _c("img", {
            staticClass: "mx-auto",
            attrs: {
              src: require("../../images/Icon/addpicture.svg"),
              width: "80"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", {}, [
          _c("button", { staticClass: "bg-green text-white p-2" }, [
            _vm._v("Select an image")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-center" }, [_vm._v("or drag and drop")])
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                                    JPG, up to 10MB\n                                "
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("img", { staticClass: "imgbox", attrs: { id: "original-preview" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "border-2 border-green" }, [
      _c("div", { staticClass: "box" }, [
        _c("img", { staticClass: "imgbox", attrs: { id: "marked-preview" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "border-2 border-green" }, [
      _c("div", { staticClass: "box" }, [
        _c("img", { staticClass: "imgbox", attrs: { id: "cropped-preview" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticClass: "mr-1 py-2 px-4 w-1/3 flex justify-center",
        attrs: { "data-tooltip": "" }
      },
      [
        _c("img", { attrs: { src: require("../../images/Icon/edit.svg") } }),
        _vm._v(" "),
        _c("div", { staticClass: "bg-green text-white tooltip p-4" }, [
          _vm._v("Reset")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/clementinefernandez/Local Sites/imatag/app/public/wp-content/themes/www/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/clementinefernandez/Local Sites/imatag/app/public/wp-content/themes/www/node_modules/vue-loader/lib?{}!./scripts/demo/WatermarkingDemo.vue?vue&type=template&id=093bb432&
// module id = 82
// module chunks = 0